export enum SchoolsAdministrationScopes {
  CAN_VIEW = 'can_view_schools_administration',
}
